import { createAction, createSlice } from "@reduxjs/toolkit";

export const saveWorkflowRequest = createAction("workflowSave/saveWorkflowRequest");
export const uploadWorkflowMediaRequest = createAction("workflowSave/uploadWorkflowMediaRequest");

const initialState = {
  response: null,
  loading: false,
  error: null,
  mediaUpload: {
    loading: false,
    activeRequestId: null,
    lastResult: null,
    error: null
  }
};

const workflowSaveSlice = createSlice({
  name: "workflowSave",
  initialState,
  reducers: {
    saveWorkflowStart(state) {
      state.loading = true;
      state.error = null;
    },
    saveWorkflowSuccess(state, action) {
      state.loading = false;
      state.response = action.payload || null;
      state.error = null;
    },
    saveWorkflowFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    workflowMediaUploadStart(state, action) {
      state.mediaUpload.loading = true;
      state.mediaUpload.activeRequestId = action.payload?.requestId || null;
      state.mediaUpload.nodeId = action.payload?.nodeId || null;
      state.mediaUpload.error = null;
    },
    workflowMediaUploadSuccess(state, action) {
      state.mediaUpload.loading = false;
      state.mediaUpload.activeRequestId = null;
      state.mediaUpload.nodeId = null;
      state.mediaUpload.error = null;
      state.mediaUpload.lastResult = action.payload || null;
    },
    workflowMediaUploadFailure(state, action) {
      state.mediaUpload.loading = false;
      state.mediaUpload.activeRequestId = null;
      state.mediaUpload.nodeId = null;
      state.mediaUpload.error = action.payload?.error || "Failed to upload media";
    },
    clearWorkflowSaveState(state) {
      state.response = null;
      state.loading = false;
      state.error = null;
      state.mediaUpload = initialState.mediaUpload;
    }
  }
});

export const {
  saveWorkflowStart,
  saveWorkflowSuccess,
  saveWorkflowFailure,
  workflowMediaUploadStart,
  workflowMediaUploadSuccess,
  workflowMediaUploadFailure,
  clearWorkflowSaveState
} = workflowSaveSlice.actions;

export default workflowSaveSlice.reducer;
